<template>
    <AppSearchComponent
            :item-per-page="25"
            :list-items="emojiFilterList"
            :ready="ready"
            search-by="emoji"

    >
        <h4 class="subheading font-weight-regular section-title--color" slot="title">Emojis</h4>
        <template v-slot:no-items>No Emoji Found</template>
        <template v-slot:list-item="{listView}">
            <div class="px-3 py-3 chip-wrapper">
                <v-chip
                        class="chip--custom-margin"
                        :class="{'tags_highlight': emojiForFilter.includes(emoji)}"
                        :key="index"
                        @click="filterByEmoji(emoji)"
                        disabled
                        outline
                        v-for="({emoji='', count=0},index) in listView"
                >
                    <v-tooltip top>
                        <template slot="activator" slot-scope="{on}">
                            <div v-on="on" class="add-cursor d-flex align-center py-1 px-1">
                                <img
                                        :src="`https://insights-analytic.bindez.com/emojis/${emojiToCodePoint(emoji)}.png`"
                                        alt="emoji-img"
                                        height="13"
                                        v-if="!isEmojiInvalid(emoji)"
                                        width="13"
                                >
                                <span v-else v-html="emoji"></span>
                                <span class="d-inline-block ml-1 emoji-tag">{{count | abbrNumber}}</span>
                            </div>
                        </template>
                        <span>{{count | formatNumber}}</span>
                    </v-tooltip>
                </v-chip>
            </div>
        </template>
    </AppSearchComponent>
</template>

<script>
	import AppSearchComponent from "../AppSearchComponent";

	import {mapState, mapMutations} from 'vuex';

	export default {
		name: "EmojiFilter",
		components: {
			AppSearchComponent
		},
		//Not Found Emoji List
		notFound: ["1f972", "1f636200d1f32bfe0f", "1f62e200d1f4a8", "1f635200d1f4ab", "1f978", "2764fe0f200d1f525", "2764fe0f200d1fa79", "1f90c", "1fac0", "1fac1", "1f9d4200d2642fe0f", "1f9d4200d2640fe0f", "1f9d1200d1f9b0", "1f9d1200d1f9b1", "1f9d1200d1f9b3", "1f9d1200d1f9b2", "1f9d1200d2695fe0f", "1f9d1200d1f393", "1f9d1200d1f3eb", "1f9d1200d2696fe0f", "1f9d1200d1f33e", "1f9d1200d1f373", "1f9d1200d1f527", "1f9d1200d1f3ed", "1f9d1200d1f4bc", "1f9d1200d1f52c", "1f9d1200d1f4bb", "1f9d1200d1f3a4", "1f9d1200d2708fe0f", "1f9d1200d1f680", "1f9d1200d1f692", "1f977", "1f935200d2642fe0f", "1f935200d2640fe0f", "1f470200d2642fe0f", "1f470200d2640fe0f", "1f469200d1f37c", "1f468200d1f37c", "1f9d1200d1f37c", "1f9d1200d1f384", "1f9d1200d1f9af", "1f9d1200d1f9bc", "1f9d1200d1f9bd", "1fac2", "1f408200d2b1b", "1f9ac", "1f9a3", "1f9ab", "1f43b200d2744fe0f", "1f9a4", "1fab6", "1f9ad", "1fab2", "1fab3", "1fab0", "1fab1", "1fab4", "1fad0", "1fad2", "1fad1", "1fad3", "1fad4", "1fad5", "1fad6", "1f9cb", "1faa8", "1fab5", "1f6d6", "1f9d1200d1f3a8", "1f6fb", "1f6fc", "1fa84", "1fa85", "1fa86", "1faa1", "1faa2", "1fa74", "1fa96", "1fa97", "1fa98", "1fa99", "1fa83", "1fa9a", "1fa9b", "1fa9d", "1fa9c", "1f6d7", "1fa9e", "1fa9f", "1faa0", "1faa4", "1faa3", "1faa5", "1faa6", "1faa7"],
		computed: {
			...mapState('sentiment', [
				'sentimentPageReady',
				'selectedEmoji'
			]),

			...mapState('mention', [
				'summaryReady'
			]),

			...mapState([
				'emojiFilterList'
			]),

			ready() {
				return this.summaryReady && this.sentimentPageReady;
			},

			emojiForFilter: {
				get() {
					return this.selectedEmoji;
				},
				set(emoji) {
					this.setSelectedEmoji(emoji)
				}
			}

		},

		methods: {

			emojiToCodePoint(emoji) {
				return [...emoji].map(c => c.codePointAt(0).toString(16)).join('');
			},

			isEmojiInvalid(emoji) {
				return this.$options.notFound.includes(this.emojiToCodePoint(emoji));
			},

			...mapMutations('sentiment', [
				'setSelectedEmoji'
			]),

			filterByEmoji(emoji) {
				this.emojiForFilter = this.emojiForFilter.includes(emoji) ?
					this.emojiForFilter.filter(item => item !== emoji) :
					[...this.emojiForFilter, emoji];
				this.$emit("filterByEmoji")
			},

		}
	}
</script>

<style scoped>
    .emoji-tag {
        user-select: none;
    }

</style>
